import {createContext, useContext} from "react";

import {ILeafletMap} from "../types/ILeafletMap";

interface OpenStreetMapContextProps {
    mapRef: ILeafletMap | null;
}

export const OpenStreetMapContext = createContext<OpenStreetMapContextProps | undefined>(undefined);

export const useOpenStreetMapContext = (): OpenStreetMapContextProps => {
    const context = useContext(OpenStreetMapContext);

    if (!context) {
        throw new Error("useOpenStreetMap must be used within an OpenStreetMapProvider");
    }

    return context;
};
